import { render, staticRenderFns } from "./Personality.vue?vue&type=template&id=340b7f44&scoped=true"
import script from "./Personality.vue?vue&type=script&lang=js"
export * from "./Personality.vue?vue&type=script&lang=js"
import style0 from "./Personality.vue?vue&type=style&index=0&id=340b7f44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "340b7f44",
  null
  
)

export default component.exports